import { ComponentVersions_3_0, ComponentVersionsInherit, Typography } from 'opensolar-ui'

const ContactTitle = ({ record, translate, style }) => {
  return (
    <ComponentVersionsInherit versions={ComponentVersions_3_0}>
      <Typography style={style}>
        {translate('Contact')} {record ? `"${record.display}"` : ''}
      </Typography>
    </ComponentVersionsInherit>
  )
}

export default {
  list: { lazy: () => import('./ContactList') },
  edit: { lazy: () => import('./form/ContactPageForm'), component: 'ContactEdit' },
  create: { lazy: () => import('./form/ContactPageForm'), component: 'ContactCreate' },
  options: {
    create: {
      title: 'Create Contact',
      subtitle: null,
      breadCrumb: 'Create Contact',
    },
    list: {
      title: 'Customer Contacts',
      subtitle:
        'Add and edit your customer contacts on this page. Customer contacts can be applied to your new and existing projects.',
      breadCrumb: 'Contacts',
    },
    edit: {
      title: <ContactTitle />,
      subtitle: null,
      breadCrumb: 'Edit Contact',
    },
  },
}

export { ContactTitle }
